import { isEmpty } from 'lodash';
import { Base64 } from 'js-base64';
import { objectToCamelCase, timestamp } from './common';

export const decodeJWT = (jwt: string | null | undefined): any => {
    if (!jwt) {
        return {};
    }

    try {
        if (jwt.split(' ').length > 1) {
            return {};
        }
        const base64 = jwt.split('.')[1].replace('-', '+').replace('_', '/');
        return objectToCamelCase(JSON.parse(Base64.decode(base64)));
    } catch (_) {
        return {};
    }
};

export interface DecodedToken {
    email: string;
    orgs: {
        agencyId?: number;
        locationId?: number;
        locationIds?: number[];
        companyId?: number;
    };
    resourceAccess?: {
        web?: {
            roles?: string[];
        };
    };
    userId?: number;
    username?: string;
    exp: number;
    [key: string]: any;
}

export const selectUserFromToken = (token: string | null | undefined) => {
    const decoded = decodeJWT(token) as DecodedToken;

    if (isEmpty(decoded)) {
        return null;
    }

    const role = decoded.resourceAccess?.web?.roles?.[0];
    return {
        email: decoded.email,
        agencyId: decoded.orgs.agencyId ?? 0,
        locationId: decoded.orgs.locationId ?? 0,
        locationIds: decoded.orgs.locationIds ?? [],
        companyId: decoded.orgs.companyId ?? 0,
        role,
        id: decoded.userId,
        computedUsername: decoded.username
    };
};

const secondInMilliseconds = 1000;
export const getTokenValidity = (token: string | null | undefined): boolean => {
    const decoded = decodeJWT(token) as DecodedToken;

    if (isEmpty(decoded)) {
        return false;
    }

    if (typeof decoded.exp !== 'number') {
        return false;
    }

    const diff = Math.floor(decoded.exp - timestamp() / secondInMilliseconds);
    return diff > 0;
};
